/* eslint-disable max-len */
import React, { SVGProps } from 'react';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

export const PiStarIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Lara_Icon">
            <path
                id="Star 6"
                d="M9.24293 3.21699C9.48946 2.49504 10.5105 2.49504 10.7571 3.21699L11.5938 5.66715C12.1941 7.42514 13.5749 8.8059 15.3328 9.40623L17.783 10.2429C18.505 10.4895 18.505 11.5105 17.783 11.7571L15.3328 12.5938C13.5749 13.1941 12.1941 14.5749 11.5938 16.3328L10.7571 18.783C10.5105 19.505 9.48946 19.505 9.24293 18.783L8.40623 16.3328C7.8059 14.5749 6.42513 13.1941 4.66715 12.5938L2.21699 11.7571C1.49504 11.5105 1.49504 10.4895 2.21699 10.2429L4.66715 9.40623C6.42514 8.8059 7.8059 7.42513 8.40623 5.66715L9.24293 3.21699Z"
                fill="url(#paint0_linear_6322_84810)"
            />
            <path
                id="Star 4"
                d="M16.6173 1.25725C16.7324 0.879214 17.2676 0.879214 17.3827 1.25725L17.7781 2.55642C17.8751 2.8753 18.1247 3.12485 18.4436 3.22191L19.7427 3.61733C20.1208 3.7324 20.1208 4.2676 19.7427 4.38267L18.4436 4.77809C18.1247 4.87515 17.8751 5.1247 17.7781 5.44358L17.3827 6.74275C17.2676 7.12079 16.7324 7.12079 16.6173 6.74275L16.2219 5.44358C16.1249 5.1247 15.8753 4.87515 15.5564 4.77809L14.2573 4.38267C13.8792 4.2676 13.8792 3.7324 14.2573 3.61733L15.5564 3.22191C15.8753 3.12485 16.1249 2.8753 16.2219 2.55642L16.6173 1.25725Z"
                fill="url(#paint1_linear_6322_84810)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_6322_84810"
                x1="-1.49012e-07"
                y1="11"
                x2="20"
                y2="11"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3E6FE5" />
                <stop offset="1" stopColor="#8241E7" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_6322_84810"
                x1="13"
                y1="4"
                x2="21"
                y2="4"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3E6FE5" />
                <stop offset="1" stopColor="#8241E7" />
            </linearGradient>
        </defs>
    </svg>
);
